import { z } from 'zod'
export const maturitySchema = z.enum(['labs', 'beta', 'stable'])
export type Maturity = z.infer<typeof maturitySchema>
